import React, { useEffect, useCallback } from 'react';

type Props = {
  visible?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
};

const UserMessages: React.FC<Props> = ({
  visible = true,
  onClose,
  children,
  title,
  description,
  className,
}) => {
  const handleKey = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose && onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (!visible) return;
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [visible, handleKey]);

  if (!visible) return null;

  return (
    <div className={`m-user-messages ${className || ''}`} role="status" aria-live="polite">
      <div className="m-user-messages__inner">
        <div className="m-user-messages__icon" aria-hidden>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.67188 7.34375C3.4375 7.8125 2.89062 8.00781 2.42188 7.8125C1.95312 7.61719 1.71875 7.07031 1.91406 6.60156C3.24219 3.47656 6.36719 1.25 10 1.25C12.0312 1.25 13.9844 2.07031 15.4297 3.51562L15.625 3.71094L16.9922 2.30469C17.2656 2.03125 17.6172 1.875 17.9688 1.875C18.75 1.875 19.375 2.5 19.375 3.28125V7.8125C19.375 8.35938 18.9453 8.75 18.4375 8.75H13.8672C13.0859 8.75 12.5 8.16406 12.5 7.38281C12.5 7.03125 12.6172 6.67969 12.8906 6.40625L14.2969 5L14.1016 4.84375C13.0078 3.75 11.5234 3.125 10 3.125C7.14844 3.125 4.6875 4.88281 3.67188 7.34375ZM18.0469 13.4766C16.6797 16.5625 13.5938 18.75 10 18.75C7.92969 18.75 5.97656 17.9688 4.53125 16.4844L4.375 16.3281L2.96875 17.7344C2.69531 18.0078 2.34375 18.125 1.99219 18.125C1.21094 18.125 0.625 17.5391 0.625 16.7578V12.1875C0.625 11.6797 1.01562 11.25 1.5625 11.25H6.09375C6.875 11.25 7.5 11.875 7.5 12.6562C7.5 13.0078 7.34375 13.3594 7.07031 13.6328L5.70312 15L5.85938 15.1953C6.95312 16.2891 8.4375 16.875 10 16.875C12.8125 16.875 15.2734 15.1953 16.2891 12.7344C16.5234 12.2266 17.0703 12.0312 17.5391 12.2266C18.0078 12.4219 18.2422 12.9688 18.0469 13.4766ZM17.5 6.875V4.45312L15.0391 6.875H17.5ZM2.5 13.125V15.5859L4.92188 13.125H2.5Z"
              fill="#262626"
            />
          </svg>
        </div>
        <div className="m-user-messages__content">
          <div className="m-user-messages__title">{title}</div>
          <div className="m-user-messages__note">{description}</div>
          {children}
        </div>
        <button
          type="button"
          className="m-user-messages__close"
          onClick={(e) => {
            e.stopPropagation();
            onClose && onClose();
          }}
          aria-label="Close"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default UserMessages;
